import React, { useEffect, useState } from "react";
import NavbarNew from "./NavbarNew";
import Sidenav from "./Sidenav";
import * as auth from "../../backend/auth";
import 'react-toastify/dist/ReactToastify.css';
import './Toaster.css';
import "./Layout.css"
import { useIdleTimer } from "react-idle-timer";
import { navigate } from "raviger";
import { getBasePath } from "../../App";
import SideNavNew from "./SidenavNew";
import { SidenavProvider, useSidenav } from "../../contexts/SidenavContext";

function AuthProtector(props: any) {
    const [authToken] = useState(auth.getAuthToken());

    const { logout: performLogout } = auth.useLogout(
        () => {
            navigate(`${getBasePath()}/`, { replace: true });
            window.location.reload();
        },
        (error: any) => {
            console.error('Auto-logout failed:', error);
            auth.clearUserSession();
            navigate(`${getBasePath()}/`, { replace: true });
            window.location.reload();
        }
    );

    function logout() {
        performLogout();
    }

    useIdleTimer({
        onIdle: () => logout(),
        timeout: 480 * 60 * 1000, // In milliseconds,
        events: [
            'keydown',
            'mousedown'
        ]
    })

    useEffect(() => {
        if (!authToken) {
            logout();
        }
    }, [authToken]);

    return (
        <>
            {
                authToken ? props.children : null
            }
        </>
    )
}

function LayoutWithSideNavContent(props: any) {
    const { open, toggleSidenav } = useSidenav();

    return (
        <AuthProtector>
            <div className="main-conatiner" >
                <NavbarNew />
                < div className="page-layout-container" >
                    <div className={`sidenav-container d-flex flex-column justify-content-between ${open ? 'open' : ''}`} >
                        <SideNavNew open={open} toggleSidenav={toggleSidenav} />
                    </div>
                    < div className="main-container" >
                        {props.children}
                    </div>
                </div>
            </div>
        </AuthProtector>
    )
}

function LayoutWithSideNav(props: any) {
    return (
        <SidenavProvider>
            <LayoutWithSideNavContent {...props} />
        </SidenavProvider>
    );
}

export default LayoutWithSideNav;